module.exports = __webpack_public_path__ + "img/5g-banner.6508932b.png";